import { render, staticRenderFns } from "./regular-papers.vue?vue&type=template&id=22a4bdf4&scoped=true&"
import script from "./regular-papers.vue?vue&type=script&lang=js&"
export * from "./regular-papers.vue?vue&type=script&lang=js&"
import style0 from "./regular-papers.vue?vue&type=style&index=0&id=22a4bdf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a4bdf4",
  null
  
)

export default component.exports